import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoSearch, IoAddOutline } from 'react-icons/io5';
import Navbar from '../lab/Navbar';
import labService from '../lab/labService';
import '../wallet/css/ManageLicences.css';

const ManageModelsAdmin = () => {
  const [models, setModels] = useState([]);
  const [filterValue, setFilterValue] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchModels = async () => {
      const token = JSON.parse(localStorage.getItem('user'))?.access;
      try {
        const response = await labService.getAllModelsAdmin(token);
        setModels(response.data);
      } catch (error) {
        console.error("Błąd pobierania modeli:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchModels();
  }, []);

  const filteredModels = models.filter(m => {
    const search = filterValue.toLowerCase();
    const modelName = (m.model_name || "").toLowerCase();
    const endpointName = (m.endpoint_name || "").toLowerCase();

    return modelName.includes(search) || endpointName.includes(search);
  });

  return (
    <div className='lab-container'>
      <Navbar />
      <div className="manage-licenses-container">
        <header className="manage-licenses-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 className='h2-title'>Manage ML Models</h2>

          <button
            className="btn btn-primary"
            onClick={() => navigate('/manage-models/create')}
          >
            <IoAddOutline size="20px" style={{ marginRight: '4px' }} />
            New model
          </button>
        </header>

        <div className="search-section">
          <div className="search-input-wrapper">
            <IoSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search by model or core..."
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        {isLoading ? (
          <div className="loading-container"><div className="spinner"></div></div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {filteredModels.length > 0 ? (
              filteredModels.map((model) => (
                <div
                  key={model.id}
                  onClick={() => navigate(`/manage-models/${model.id}`)}
                  style={{
                    backgroundColor: '#fff',
                    border: '1px solid #e2e8f0',
                    borderLeft: '5px solid #3182ce',
                    borderRadius: '8px',
                    padding: '20px 25px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.02)';
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <div style={{ color: '#a0aec0', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 'bold', marginBottom: '4px' }}>
                      {model.endpoint_name || 'No Endpoint'} &nbsp;|&nbsp; {model.version_name || 'v1.0.0'}
                    </div>
                    <strong style={{ fontSize: '1.25rem', color: '#1B4480', display: 'block', marginBottom: '6px' }}>
                      {model.model_name || 'Unnamed Model'}
                    </strong>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <span style={{ fontSize: '0.8rem', backgroundColor: '#edf2f7', color: '#4a5568', padding: '2px 8px', borderRadius: '4px' }}>
                        {model.model_category || 'No category'}
                      </span>
                      <span style={{ fontSize: '0.8rem', backgroundColor: '#e6fffa', color: '#285e61', padding: '2px 8px', borderRadius: '4px' }}>
                        {model.method_type || 'Unknown'}
                      </span>
                    </div>
                  </div>

                  <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <span style={{ color: '#718096', fontSize: '0.9rem', marginBottom: '4px' }}>Metric</span>
                    <strong style={{ fontSize: '1.1rem', color: '#2d3748' }}>
                      {model.primary_metric || '-'}
                    </strong>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-placeholder">
                No models found matching your search.
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageModelsAdmin;
